import { Controller } from "stimulus";
import { __ } from "locale";

export default class extends Controller {
  static targets = ["file", "cache", "buttonContainer", "result", "checkbox"];

  connect() {
    this.checkboxTargets.forEach(checkbox => {
      checkbox.addEventListener("change", this.toggleCheckboxes.bind(this));
    });
  }

  addFile(e) {
    e.preventDefault();

    if (e.detail === 1) {
      this.fileTarget.click();
    }
  }

  removeFile(e) {
    e.preventDefault();

    this.buttonContainerTarget.classList.remove("d-none");
    this.resultTarget.classList.add("d-none");
    this.resultTarget.classList.remove("d-flex");
    this.resultTarget.innerHTML = "";
    this.fileTarget.value = "";
    this.cacheTarget.value = "";
  }

  uploadFile(e) {
    e.preventDefault();

    this.buttonContainerTarget.classList.add("d-none");
    this.resultTarget.classList.remove("d-none");
    [...this.fileTarget.files].forEach(file => {
      this.resultTarget.innerHTML += `
      <div id=${file.name} >
        <i class="far fa-check-circle text-success mr-10px""></i>${file.name}
      </div>
    `;    });
    this.resultTarget.innerHTML += `
        <a class="small link-muted ml-auto" href="#" data-action="upload#removeFile">${__("Entfernen")}</a>
    `;
  }

  toggleCheckboxes(e) {
    const currentChecked = e.target;
    // Disable all checkboxes except the currently checked one
    this.checkboxTargets.forEach(checkbox => {
      if (checkbox !== currentChecked) {
        checkbox.disabled = currentChecked.checked;
      }
    });

    // Optionally, show a message
    if (currentChecked.checked) {
      const message = document.querySelector(".popup-message");
      if (message) {
        message.classList.remove("d-none");
        message.innerHTML = "Ein anderer Aktuelle News Eintrag ist bereits im automatischem Popup Fenster, bitte zuerst diesen deaktivieren";
      }
    } else {
      const message = document.querySelector(".popup-message");
      if (message) {
        message.classList.add("d-none");
      }
    }
  }
}
